module.exports = __webpack_public_path__ + "static/media/pad-technology_Sahara-Forest-Project-Foundation_crop_mobile.fd46a30b.jpg";